<div
    [attr.role]="announcementRole()"
    class="
    flex
    items-start
    border
    rounded
    p-2.5
    gap-2.5
    {{ colorClasses() }}"
>
    @if (showIcon()) {
        <div class="shrink-0">
            <fa-icon [icon]="icon()" size="lg" aria-hidden="true"></fa-icon>
            <span class="sr-only">{{ severityLabel() }}</span>
        </div>
    }
    <div class="min-w-0 flex-1">
        <ng-content></ng-content>
    </div>
</div>
